/**
 * @generated SignedSource<<d25bc54d42d0a86d44794bdc8d6789c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueTableHierarchyToggle_HierarchyToggle$data = {
  readonly id: string;
  readonly viewId: string | null | undefined;
  readonly viewSettings?: {
    readonly canEnableGrouping: boolean | null | undefined;
    readonly canEnableHierarchy: boolean | null | undefined;
    readonly isGroupingEnabled: boolean | null | undefined;
    readonly isHierarchyEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ui_issueTableHierarchyToggle_HierarchyToggle";
};
export type ui_issueTableHierarchyToggle_HierarchyToggle$key = {
  readonly " $data"?: ui_issueTableHierarchyToggle_HierarchyToggle$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableHierarchyToggle_HierarchyToggle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "groupBy"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "ui_issueTableHierarchyToggle_HierarchyToggle",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "viewId"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "groupBy",
              "variableName": "groupBy"
            },
            {
              "kind": "Variable",
              "name": "issueSearchInput",
              "variableName": "issueSearchInput"
            },
            {
              "kind": "Variable",
              "name": "staticViewInput",
              "variableName": "staticViewInput"
            }
          ],
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewSettings",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isHierarchyEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "canEnableHierarchy"
            },
            {
              "kind": "ScalarField",
              "name": "isGroupingEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "canEnableGrouping"
            }
          ]
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "ce946b6314755bfe6dc04ff010764974";

export default node;
